import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import "./SearchBar.css";

const SearchBar = ({ placeholder, onSearch }) => {
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    setQuery(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <div className="search-bar">
      <FiSearch className="search-icon" />
      <input
        type="text"
        placeholder={placeholder || "Search..."}
        value={query}
        onChange={handleSearch}
      />
    </div>
  );
};

export default SearchBar;
